import cn from 'classnames';
import React from 'react';

interface SearchFieldProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;

  showClear?: boolean;
  borderColor?: string;
  searchIcon?: string;

  textColor?: string;
  placeholderColor?: string;
  textSize?: string;
}

const SearchField = ({
  value,
  onChange,
  onBlur,
  showClear = true,

  borderColor = 'border-gray-300',
  textColor = 'text-gray-900',
  placeholderColor = 'placeholder-gray-300',
  textSize = 'text-md',

  searchIcon = 'icon-nameSearch',
  className,
  placeholder,
  ...props
}: SearchFieldProps) => {
  return (
    <div
      className={cn(
        'relative flex items-center border rounded-md w-full h-10 px-3 box-border flex-shrink-0',
        borderColor,
        className,
      )}
    >
      {searchIcon && (
        <i className={cn('absolute right-3 text-gray-400', searchIcon)} />
      )}

      <input
        {...props}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        className={cn(
          'w-full h-full bg-transparent outline-none pr-4 leading-none',
          textColor,
          placeholderColor,
          textSize,
        )}
      />

      {showClear && value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute text-gray-400 left-3 hover:text-gray-600"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchField;
